import { Box, Button, CircularProgress, Container, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { themePalette } from "../../config/theme.config";
import { useAppSelector } from "../../redux/hooks";
import { PublicoAgrupado } from "./PublicoAgrupado";

export const UserPage: React.FC<{}> = () => {
    const { isAuth,userData } = useAppSelector((state) => state.authReducer);
    const [loading0, setLoading0] = useState(true);
    const [loading1, setLoading1] = useState(true);
    const [tab, setTab] = useState(0);

    //Funciones
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
        //console.log(newValue);
    };

    // effect
    useEffect(() => {
        if(isAuth){
            console.log(userData);
            setLoading0(false);
            setLoading1(false);
        }
    }, [isAuth, userData]);

    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center', marginTop: 10, border: `1px solid ${themePalette.NAVCOLOR}`, borderTopWidth: '3px', borderRadius: '5px' }}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                    Mi Perfil
                </Typography>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Tabs
                    value={tab}
                    onChange={handleTabChange}
                    aria-label="Pestañas interactivas"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Público" id="tab-0" aria-controls="tabpanel-0" />
                    <Tab label="Intereses" id="tab-1" aria-controls="tabpanel-1" />
                </Tabs>
            </Box>
            {/* Panel de contenido */}
            <Box sx={{ width: '100%', mt: 2 }}>
                <Grid container spacing={1}>
                    {tab === 0 && (<>
                        {loading0 ?
                            <Grid item xs={12}>
                                <CircularProgress />
                            </Grid>
                            : <>
                            <Grid item sm={12} lg={12} >
                                <PublicoAgrupado publico={userData.publico} />
                            </Grid>
                            </>
                        }
                    </>
                    )}
                    {tab === 1 && (
                        <>
                            {loading1 ?
                                <Grid item xs={12}>
                                    <CircularProgress />
                                </Grid>
                                : <>
                                    Intereses
                                </>
                            }
                        </>
                    )}
                </Grid>
            </Box>
        </Container>
    )
}